import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Select from "react-select";

import * as actions from "../../actions";
import * as Template from "../../templates";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = "attributes";
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()
  const navigate = useNavigate()
  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [option, setOption] = useState(``);
  const [multiple, setMultiple] = useState(``);
  const [state, setState] = useState(``);
  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);
  const [required, setRequired] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const handleChangeState = (value) => setState(value);
  const handleChangeRequired = (value) => setRequired(value);

  const handleChangeMultiple = (value) => setMultiple(value);
  const handleChangeOption = (value) => setOption(value);
  const onChangeCategory = value => setCategoryId(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true);
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.attributes_store != undefined &&
          appReducer.attributes_store.error == false) ||
        (appReducer.attributes_update != undefined &&
          appReducer.attributes_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false);
  }, [appReducer.attributes_store, appReducer.attributes_update]);

  useEffect(() => {
    if (
      appReducer.attributes_edit != undefined &&
      id != undefined
    ) {
      let row = appReducer.attributes_edit.data;
      setName(row.name);

      setRequired({
        value: row.required,
        label: row.required == `required` ? 'هست' : 'نیست'
      });

      setOption({
        value: row.option,
        label: row.option == `optional` ? 'گزینه دارد' : 'بدون گزینه'
      });
      setMultiple({
        value: row.multiple,
        label: row.multiple == `multiple` ? 'بله' : 'خیر'
      });
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });

      let multiCategories = [];
      if (row.attribute_categories != null) {
        row.attribute_categories.map((attribute_category) => {
          multiCategories.push({
            value: attribute_category.id,
            label: attribute_category.name
          });
        });
      }

      setCategoryId(multiCategories);
    }
  }, [appReducer.attributes_edit]);

  useEffect(() => {
    if (appReducer.attribute_categories_option_list != undefined) {
      setCategories(appReducer.attribute_categories_option_list.data);
    }
  }, [appReducer.attribute_categories_option_list]);

  useEffect(() => {
    dispatch(actions.list(`attribute_categories/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  

  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <div className="form-group">
      <label>گروه </label>
      <Select
        placeholder="انتخاب ..."
        isMulti
        isRtl={true}
        name="attribute_category_id[]"
        onChange={onChangeCategory}
        options={categories}
        value={categoryId}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    </div>
    <Template.SingleSelect
      withLabel
      placeholder="الزامی بودن فیلد"
      onChange={handleChangeRequired}
      name="required"
      required
      value={required}
      options={[
        {
          value: 'required',
          label: "هست",
        },
        {
          value: 'not_required',
          label: "نیست",
        }
      ]}
    />

    <Template.SingleSelect
      withLabel
      placeholder="وضعیت گزینه‌ها"
      required
      onChange={handleChangeOption}
      name="option"
      value={option}
      options={[
        {
          value: "optional",
          label: "گزینه دارد",
        },
        {
          value: "simple",
          label: "بدون گزینه",
        }
      ]}
    />

    {option.value == 'optional' ? <Template.SingleSelect
      withLabel
      placeholder="چندگزینه ای"
      onChange={handleChangeMultiple}
      name="multiple"
      value={multiple}
      options={[
        {
          value: "multiple",
          label: "بله",
        },
        {
          value: "single",
          label: "خیر",
        },
      ]}
    /> : ''}


    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"
      onClick={handleClick}
    />
  </Template.Form>
};
